import { Input, InputFile, Textarea, Checkbox, Modal } from 'components/common'
//import HtmlEditor from 'components/html-editor'

const shares = {
	0: {icon: 'la la-user-lock', label: __('socials_share_private'), disabled: true},
	1: {icon: 'la la-user-friends', label: __('socials_share_followers'), disabled: true},
	2: {icon: 'la la-user-circle', label: __('socials_share_partners')},
	3: {icon: 'la la-users', label: __('socials_share_public')}
}

export const feedTypes = {
	1: { title: __('socials_photo'), subtitle: __('socials_my_comment') },
	2: { title: __('socials_video'), subtitle: __('socials_my_comment') },
	3: { title: __('socials_news'), subtitle: __('socials_news') },
	4: { title: __('socials_file'), subtitle: __('socials_my_comment') }
}

export default class FeedEditor extends Modal {
	constructor(props) {
		super(props);
		this.state = {
			title: __('socials_publication') + " (" + feedTypes[props.model.type].title + ")",
			href: props.model.href_image || props.model.href || false
		}
		this.editors = {
			1: model => (
				<div>
					{this.state.href
						? <div className="file">
							<div className="btn-group btn-group-sm mt-1" style={{position: 'absolute', right: '10px'}}>
								<button className="btn btn-light" onClick={() => this.setState({href: false})}>
									<em className="la la-file-image" />
									<span>{__('attrs_change_photo')}</span>
								</button>
							</div>
							{props.model.type != 4
								? <img src={this.state.href} />
								: <div className="center">
									<em className="la la-paperclip" />
									<span className="block">{props.model.attachname || null}</span>
								  </div>
							}
						  </div>
						: <div>
							<InputFile type='image' onChange={this.onSelectFile.bind(this)} />
							<div className="float-right">{__('socials_dims', {ratio: __('socials_post_dims')})}</div>
						  </div>
					}
				</div>),
			2: model => (
				<div className="video">
					<Input className="form-control" model={model} name="href" placeholder={__('socials_youtube_link_share')} onChange={this.onChangeHref.bind(this)} />
					<span className="tip">{__('socials_youtube_share_tip', {}, true)}</span>
					{this.state.href
						? <iframe
							width="100%" height="349"
							src={this.state.href + '?autoplay=0'}
							frameBorder="0"
							allowFullScreen
						  />
						: null}
				</div>),
			3: model => (
				<div className="news-editor">
					<Input className="form-control" model={model} name="name" placeholder={__('attrs_title')} onChange={this.onChange.bind(this, name)} />
					{this.state.href
						? <div className="file">
							<div className="float-right btn-group btn-group-sm mt-1">
								<button className="btn btn-light" onClick={() => this.setState({href: false})}>
									<em className="la la-file-image" />
									<span>{__('attrs_change_photo')}</span>
								</button>
							</div>
							<img src={this.state.href} />
						  </div>
						: <InputFile type="image" onChange={this.onSelectFile.bind(this)} />
					}
				</div>),
			4: model => this.editors[1]()
		}
	}

	onSelectFile(e) {
		const { model } = this.props;
		model.file = e.currentTarget.files[0];
		this.forceUpdate();
	}

	onChange() {
		this.forceUpdate();
	}

	onChangeHref() {
		// validate href
		const { model } = this.props;

		if (model.href) {
			if (model.type == 2) {
				const t = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
				const match = model.href.match(t);
				this.setState({href: match && match[2].length === 11 ? ('https://www.youtube.com/embed/' + match[2]) : false});
				return;
			}
			//return /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(\?\S*)?$/.test(model.href)
		}
		this.setState({href: false});
	}

	onPublish() {
		const { model, user } = this.props;
		const data = new FormData();

		if (model.id) {
			data.append('id', model.id)
		}
		data.append('type', model.type)
		data.append('share', model.share)
		data.append('href', this.state.href || null)
		data.append('name', model.name);
		data.append('title', model.title);
		data.append('comment', model.comment);
		data.append('tags', model.tags);
		data.append('lang', model.lang || '');
		if (model.file != null) {
			data.append('file', model.file);
		}
		http.post('/home/publish.json', {
			type: 'POST',
			data: data
		}, (response, success) => {
			user.saveContent(response.feed);
			this.props.onClose();
		})
	}

	onDelete() {
		const { model, user } = this.props;
		mbox.confirmDelete(
			() => {
				mbox.dismiss();
				http.post('/home/deletePub.json', {
					type: 'POST',
					data: {id: model.id}
				}, (response, success) => {
					if (success) {
						user.deleteFeed(model);
						this.props.onClose();
					}
				})
			},
			model.comment
		);
	}

	onNext() {
		const { model } = this.props;

		model._show_help = 0;
		this.forceUpdate();
	}

	renderButtons() {
		const { model } = this.props;

		if (model._show_help == 1) {
			return [
				<div key="l"></div>,
				<div key='r' className="btn-group btn-group-sm">
					<button className='btn btn-light' title={__('buttons_close')} onClick={this.onClose.bind(this)}>
						<em className="la la-min la-times" />
						<span>{__('buttons_cancel')}</span>
					</button>
					<button className='btn btn-primary' onClick={this.onNext.bind(this)}>
						<em className="la la-arrow-alt-circle-right" />
						<span>{__('buttons_next')}</span>
					</button>
				</div>
			]
		}
		const _shares = Object.keys(shares).filter(i => shares[i].disabled !== true).map(i => (
			<a key={i} className="dropdown-item" href="#" onClick={() => {
				model.share = i;
				this.forceUpdate();
			}}>
				<em className={shares[i].icon} />
				<span>{shares[i].label}</span>
			</a>
		))
		const enabled = (model.file != null || this.state.href);
		return [
			<div key='l' className="btn-group btn-group-sm mr-auto">
				<div className="btn-group btn-group-sm" role="group">
					<button type="button" className="btn btn-light dropdown-toggle" data-toggle="dropdown">
						<em className={shares[model.share].icon} />
						<span>{shares[model.share].label}</span>
					</button>
					<div className="dropdown-menu">
						{_shares}
					</div>
				</div>
			</div>,
			<div key='r' className="btn-group btn-group-sm">
				<button className='btn btn-light' title={__('buttons_close')} onClick={this.onClose.bind(this)}>
					<em className="la la-min la-times" />
					<span>{__('buttons_cancel')}</span>
				</button>
				{model.id
					? <button className='btn btn-danger' onClick={this.onDelete.bind(this)} title={__('buttons_delete')}>
						<em className="la la-min la-trash" />
					  </button>
					: null}
				<button className='btn btn-primary' disabled={!enabled} onClick={this.onPublish.bind(this)}>
					<em className="la la-min la-share" />
					<span>{__('actions_publish')}</span>
				</button>
			</div>
		]
	}

	onToggleType(type) {
		const { model } = this.props;
		
		model.type = type == 1 && model.attachname ? 4 : type;
		this.setState({ title: __('socials_publication') + " (" + feedTypes[model.type].title + ")" });
	}

	changeLocale(code) {
		const { model } = this.props;
		model.lang = code;
		this.forceUpdate();
	}

	renderChildren() {
		const { model } = this.props;
		const locales = Object.keys(hp.store.locales).map(code => {
			const l = hp.store.locales[code];
			return (
				<button
					key={code}
					onClick={this.changeLocale.bind(this, code)}
					className={classNames('btn', code == model.lang ? 'btn-primary' : 'btn-light')}
					title={__('socials_feed_idiom_' + code)}
				>
					<img src={"/public/admin/img/flags/" + l.idiom + ".png"} />
				</button>
			);
		})
		locales.unshift(
			<button
				key='a'
				onClick={this.changeLocale.bind(this, null)}
				className={classNames('btn', model.lang == null ? 'btn-primary' : 'btn-light')}
				title={__('socials_feed_idiom_all')}
			>
				<span>{__('attrs_both_f')}</span>
			</button>
		);

		if (model._show_help) {
			return (
				<div className="pcontent">
					<h5>{__('socials_posteditor_help_title')}</h5>
					<p>
						{locales}
					</p>
					<div className="form-check">
					    <input type="checkbox" className="form-check-input"
							id="help_create_post"
							checked={hp.store.config.help_create_post == 0}
							onChange={() => {
								let value = hp.store.config.help_create_post == 1 ? 0 : 1;
								http.post('home/setHelpCreatePost.json', {
									value: value,
									silent: true
								}, (response, success) => {
									if (success) {
										hp.store.config.help_create_post = value;
									}
									this.forceUpdate();
								})
							}} />
						<label className="form-check-label" htmlFor="help_create_post">{__('actions_dont_show_again')}</label>
    					<small className="form-text text-muted">{__('socials_posteditor_help_body')}</small>
						<p></p>
						<div><small>{__('socials_feed_idiom_all')}</small></div>
						<div><small>{__('socials_feed_idiom_pt-pt')}</small></div>
						<div><small>{__('socials_feed_idiom_de-de')}</small></div>
					</div>
				</div>
			)
		}
		return (
			<div className="feed-editor">
				<div>
					<div className="btn-group btn-group-sm">
						<button
							 className={classNames("btn", model.type == 1 || model.type == 4 ? 'btn-primary' : 'btn-light')}
							 onClick={this.onToggleType.bind(this, 1)}
						>
							{__('socials_photo')}/{__('socials_image')}/{__('socials_file')}
						</button>
						<button
							 className={classNames("btn", model.type == 2 ? 'btn-primary' : 'btn-light')}
							 onClick={this.onToggleType.bind(this, 2)}
						>
							{__('socials_video_youtube')}
						</button>
					</div>
					<div className="btn-group btn-group-sm float-right">
						{locales}
					</div>
					<div className="clearfix" />
					{this.editors[model.type](model)}
				</div>
				<Input model={model} name="title" placeholder={__('attrs_title')} />
				<div className="subtitle">
					<label htmlFor="comment">{feedTypes[model.type].subtitle}:</label>
				</div>
				<Textarea model={model} name='comment' className="form-control" rows={6} />

				<div className="subtitle">
					<label>{__('metadata_keywords')}</label>
				</div>
				<Textarea model={model} name="tags" className="form-control" rows={3} maxLength={250} />
				<div className="float-right">{__('tips_max_chars', {value: 250})}</div>
			</div>
		);
	}
}
